import { motion } from "framer-motion";
import { PlaneLanding, Repeat, UserRoundCheck, ArrowRight } from "lucide-react";
import { waLink } from "@/lib/brand";
import { useT } from "@/lib/i18n";

export default function Audiences() {
  const { t } = useT();
  const items = [
    { id: "newcomers", icon: PlaneLanding, titleKey: "aud.new.title", textKey: "aud.new.text", msgKey: "aud.new.msg" },
    { id: "already-here", icon: Repeat, titleKey: "aud.change.title", textKey: "aud.change.text", msgKey: "aud.change.msg" },
    { id: "replacement", icon: UserRoundCheck, titleKey: "aud.replace.title", textKey: "aud.replace.text", msgKey: "aud.replace.msg" },
  ];

  return (
    <section id="who-we-help" data-testid="audiences-section" className="relative py-20 md:py-24 bg-[#0B1733]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="text-xs tracking-[0.3em] text-gold uppercase mb-4">{t("aud.eyebrow")}</div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white leading-tight max-w-2xl">
              {t("aud.title.1")}{" "}
              <span className="italic text-gold">{t("aud.title.2")}</span>
            </h2>
          </div>
          <p className="text-slate-400 max-w-md leading-relaxed">{t("aud.blurb")}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {items.map((a, i) => (
            <motion.a
              key={a.id}
              href={waLink(t(a.msgKey))}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`audience-${a.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group relative overflow-hidden bg-navy-800/60 hover:bg-navy-800 border border-gold/20 hover:border-gold/60 rounded-2xl p-7 transition-[background-color,border-color] duration-300"
            >
              <div className="flex items-start justify-between gap-4 mb-5">
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gold/10 border border-gold/30 text-gold group-hover:bg-gold group-hover:text-navy-900 transition-[color,background-color,border-color,box-shadow,transform]">
                  <a.icon className="h-5 w-5" />
                </div>
                <div className="h-8 w-8 rounded-full border border-gold/30 text-gold/70 inline-flex items-center justify-center group-hover:bg-gold group-hover:text-navy-900 group-hover:border-gold transition-[color,background-color,border-color,box-shadow,transform]">
                  <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
                </div>
              </div>
              <h3 className="font-serif text-2xl text-white mb-2 leading-snug">{t(a.titleKey)}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{t(a.textKey)}</p>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
